/**
 * Simulated aviation radiation data for web platform
 * Used when camera is not available (web) for demo/testing
 */

/** Simulated hits/sec at 35k ft, mid-latitude - varies slightly over time */
export function getSimulatedHitsPerSecond(): number {
  const base = 6;
  const variation = Math.sin(Date.now() / 5000) * 1.5;
  return Math.max(0.5, base + variation);
}

/** Simulated dose rate µSv/h for given altitude */
export function getSimulatedDoseRateMicroSvPerHour(altitudeFeet: number): number {
  const base = 4;
  const altFactor = Math.pow(altitudeFeet / 35_000, 1.2);
  const variation = Math.sin(Date.now() / 8000) * 0.5;
  return Math.round((base * altFactor + variation) * 100) / 100;
}
